export interface BuildInfo {
  app: string;
  version: string;
  environment: string;
  commitSha: string;
}

// Logs version/environment/commit info to the devtools console on load. It is
// not rendered in the UI, but gives QA an exact build fingerprint.
export function logBuildInfo({
  app,
  version,
  environment,
  commitSha,
}: BuildInfo) {
  const shortSha = commitSha ? commitSha.slice(0, 7) : 'local dev';

  console.info(
    `%c ${app} %c`,
    'background:#711FFF;color:#fff;font-weight:bold;padding:2px 6px;border-radius:3px;',
    'background:transparent;',
    `\n- Version: ${version}\n- Environment: ${environment}\n- Commit: ${shortSha}`,
  );
}
